import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as adviceKMZazIetOQMeta } from "/app/pages/advice.vue?macro=true";
import { default as editAXDRGQVz95Meta } from "/app/pages/announcements/[slug]/edit.vue?macro=true";
import { default as indextpw0FgipCpMeta } from "/app/pages/announcements/[slug]/index.vue?macro=true";
import { default as previewB28BXEU4PfMeta } from "/app/pages/announcements/[slug]/preview.vue?macro=true";
import { default as business_45sale0WMtXcnDS0Meta } from "/app/pages/announcements/new/business-sale.vue?macro=true";
import { default as franchisejURPkl0mbjMeta } from "/app/pages/announcements/new/franchise.vue?macro=true";
import { default as investmentjaiqU6YYMeMeta } from "/app/pages/announcements/new/investment.vue?macro=true";
import { default as faqpWnoPEDLRqMeta } from "/app/pages/cabinet/admin/blog/edit/[id]/faq.vue?macro=true";
import { default as filebqcY9MnRx9Meta } from "/app/pages/cabinet/admin/blog/edit/[id]/file.vue?macro=true";
import { default as linkwTEKp3vS2rMeta } from "/app/pages/cabinet/admin/blog/edit/[id]/link.vue?macro=true";
import { default as newsqEDpYBhmqpMeta } from "/app/pages/cabinet/admin/blog/edit/[id]/news.vue?macro=true";
import { default as faqqfmE4UIH5qMeta } from "/app/pages/cabinet/admin/blog/faq.vue?macro=true";
import { default as filesNehs6a3BdqMeta } from "/app/pages/cabinet/admin/blog/files.vue?macro=true";
import { default as indexfDrCh5Rxp1Meta } from "/app/pages/cabinet/admin/blog/index.vue?macro=true";
import { default as linksHgAkqa8fKwMeta } from "/app/pages/cabinet/admin/blog/links.vue?macro=true";
import { default as faqyWKHXmPuOIMeta } from "/app/pages/cabinet/admin/blog/new/faq.vue?macro=true";
import { default as filec6goFyR0rAMeta } from "/app/pages/cabinet/admin/blog/new/file.vue?macro=true";
import { default as linkvIc9fbzCZmMeta } from "/app/pages/cabinet/admin/blog/new/link.vue?macro=true";
import { default as newsCEikQBNDqGMeta } from "/app/pages/cabinet/admin/blog/new/news.vue?macro=true";
import { default as newsZQbJLj3k3SMeta } from "/app/pages/cabinet/admin/blog/news.vue?macro=true";
import { default as contacts_45requestsjwwzQBJQCIMeta } from "/app/pages/cabinet/admin/contacts-requests.vue?macro=true";
import { default as franchisesDeyTRd2XISMeta } from "/app/pages/cabinet/admin/franchises.vue?macro=true";
import { default as index7eqYmXLl0NMeta } from "/app/pages/cabinet/admin/index.vue?macro=true";
import { default as managersW2uE2QEN2uMeta } from "/app/pages/cabinet/admin/managers.vue?macro=true";
import { default as stat7Jhwz6YuXwMeta } from "/app/pages/cabinet/admin/stat.vue?macro=true";
import { default as dashboardKHX7remamBMeta } from "/app/pages/cabinet/dashboard.vue?macro=true";
import { default as indexnwhO39W8KgMeta } from "/app/pages/cabinet/index.vue?macro=true";
import { default as profile2UaO9VJ68ZMeta } from "/app/pages/cabinet/profile.vue?macro=true";
import { default as contactV6oPJjs9RyMeta } from "/app/pages/contact.vue?macro=true";
import { default as accountingd2D4O1qhMqMeta } from "/app/pages/documents/accounting.vue?macro=true";
import { default as cookieskuN9HXVNZWMeta } from "/app/pages/documents/cookies.vue?macro=true";
import { default as discount_45codeszaQsZGC9STMeta } from "/app/pages/documents/discount-codes.vue?macro=true";
import { default as rodoeVLCahDp5gMeta } from "/app/pages/documents/rodo.vue?macro=true";
import { default as indexOMNLV5eKxsMeta } from "/app/pages/franchising/index.vue?macro=true";
import { default as page_45_91_58page_93ahpi1NAyjDMeta } from "/app/pages/franchising/page-[:page].vue?macro=true";
import { default as editrEPR6PUfiKMeta } from "/app/pages/invoice/[id]/edit.vue?macro=true";
import { default as indexvxYgcCJQGtMeta } from "/app/pages/invoice/index.vue?macro=true";
import { default as my_45infoPkQHrCIZFrMeta } from "/app/pages/invoice/my-info.vue?macro=true";
import { default as my_45invoicesg5wtmcDfRuMeta } from "/app/pages/invoice/my-invoices.vue?macro=true";
import { default as _91slug_93h6ecm9GkHAMeta } from "/app/pages/news/[slug].vue?macro=true";
import { default as pricesC8xY6SsZYuMeta } from "/app/pages/prices.vue?macro=true";
import { default as restore_45passwordjv2H2Dzb0tMeta } from "/app/pages/restore-password.vue?macro=true";
import { default as _91slug_93Z02nD6l35AMeta } from "/app/pages/services/[slug].vue?macro=true";
import { default as _91secret_93KYyR3t42ojMeta } from "/app/pages/verify-email/[secret].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "advice___en",
    path: "/en/advice",
    component: () => import("/app/pages/advice.vue")
  },
  {
    name: "advice___uk",
    path: "/uk/advice",
    component: () => import("/app/pages/advice.vue")
  },
  {
    name: "advice___pl",
    path: "/pl/advice",
    component: () => import("/app/pages/advice.vue")
  },
  {
    name: "advice___ru",
    path: "/ru/advice",
    component: () => import("/app/pages/advice.vue")
  },
  {
    name: "announcements-slug-edit___en",
    path: "/en/announcements/:slug()/edit",
    component: () => import("/app/pages/announcements/[slug]/edit.vue")
  },
  {
    name: "announcements-slug-edit___uk",
    path: "/uk/announcements/:slug()/edit",
    component: () => import("/app/pages/announcements/[slug]/edit.vue")
  },
  {
    name: "announcements-slug-edit___pl",
    path: "/pl/announcements/:slug()/edit",
    component: () => import("/app/pages/announcements/[slug]/edit.vue")
  },
  {
    name: "announcements-slug-edit___ru",
    path: "/ru/announcements/:slug()/edit",
    component: () => import("/app/pages/announcements/[slug]/edit.vue")
  },
  {
    name: "announcements-slug___en",
    path: "/en/announcements/:slug()",
    component: () => import("/app/pages/announcements/[slug]/index.vue")
  },
  {
    name: "announcements-slug___uk",
    path: "/uk/announcements/:slug()",
    component: () => import("/app/pages/announcements/[slug]/index.vue")
  },
  {
    name: "announcements-slug___pl",
    path: "/pl/announcements/:slug()",
    component: () => import("/app/pages/announcements/[slug]/index.vue")
  },
  {
    name: "announcements-slug___ru",
    path: "/ru/announcements/:slug()",
    component: () => import("/app/pages/announcements/[slug]/index.vue")
  },
  {
    name: "announcements-slug-preview___en",
    path: "/en/announcements/:slug()/preview",
    component: () => import("/app/pages/announcements/[slug]/preview.vue")
  },
  {
    name: "announcements-slug-preview___uk",
    path: "/uk/announcements/:slug()/preview",
    component: () => import("/app/pages/announcements/[slug]/preview.vue")
  },
  {
    name: "announcements-slug-preview___pl",
    path: "/pl/announcements/:slug()/preview",
    component: () => import("/app/pages/announcements/[slug]/preview.vue")
  },
  {
    name: "announcements-slug-preview___ru",
    path: "/ru/announcements/:slug()/preview",
    component: () => import("/app/pages/announcements/[slug]/preview.vue")
  },
  {
    name: "announcements-new-business-sale___en",
    path: "/en/announcements/new/business-sale",
    component: () => import("/app/pages/announcements/new/business-sale.vue")
  },
  {
    name: "announcements-new-business-sale___uk",
    path: "/uk/announcements/new/business-sale",
    component: () => import("/app/pages/announcements/new/business-sale.vue")
  },
  {
    name: "announcements-new-business-sale___pl",
    path: "/pl/announcements/new/business-sale",
    component: () => import("/app/pages/announcements/new/business-sale.vue")
  },
  {
    name: "announcements-new-business-sale___ru",
    path: "/ru/announcements/new/business-sale",
    component: () => import("/app/pages/announcements/new/business-sale.vue")
  },
  {
    name: "announcements-new-franchise___en",
    path: "/en/announcements/new/franchise",
    component: () => import("/app/pages/announcements/new/franchise.vue")
  },
  {
    name: "announcements-new-franchise___uk",
    path: "/uk/announcements/new/franchise",
    component: () => import("/app/pages/announcements/new/franchise.vue")
  },
  {
    name: "announcements-new-franchise___pl",
    path: "/pl/announcements/new/franchise",
    component: () => import("/app/pages/announcements/new/franchise.vue")
  },
  {
    name: "announcements-new-franchise___ru",
    path: "/ru/announcements/new/franchise",
    component: () => import("/app/pages/announcements/new/franchise.vue")
  },
  {
    name: "announcements-new-investment___en",
    path: "/en/announcements/new/investment",
    component: () => import("/app/pages/announcements/new/investment.vue")
  },
  {
    name: "announcements-new-investment___uk",
    path: "/uk/announcements/new/investment",
    component: () => import("/app/pages/announcements/new/investment.vue")
  },
  {
    name: "announcements-new-investment___pl",
    path: "/pl/announcements/new/investment",
    component: () => import("/app/pages/announcements/new/investment.vue")
  },
  {
    name: "announcements-new-investment___ru",
    path: "/ru/announcements/new/investment",
    component: () => import("/app/pages/announcements/new/investment.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-faq___en",
    path: "/en/cabinet/admin/blog/edit/:id()/faq",
    meta: faqpWnoPEDLRqMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/faq.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-faq___uk",
    path: "/uk/cabinet/admin/blog/edit/:id()/faq",
    meta: faqpWnoPEDLRqMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/faq.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-faq___pl",
    path: "/pl/cabinet/admin/blog/edit/:id()/faq",
    meta: faqpWnoPEDLRqMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/faq.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-faq___ru",
    path: "/ru/cabinet/admin/blog/edit/:id()/faq",
    meta: faqpWnoPEDLRqMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/faq.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-file___en",
    path: "/en/cabinet/admin/blog/edit/:id()/file",
    meta: filebqcY9MnRx9Meta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/file.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-file___uk",
    path: "/uk/cabinet/admin/blog/edit/:id()/file",
    meta: filebqcY9MnRx9Meta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/file.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-file___pl",
    path: "/pl/cabinet/admin/blog/edit/:id()/file",
    meta: filebqcY9MnRx9Meta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/file.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-file___ru",
    path: "/ru/cabinet/admin/blog/edit/:id()/file",
    meta: filebqcY9MnRx9Meta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/file.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-link___en",
    path: "/en/cabinet/admin/blog/edit/:id()/link",
    meta: linkwTEKp3vS2rMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/link.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-link___uk",
    path: "/uk/cabinet/admin/blog/edit/:id()/link",
    meta: linkwTEKp3vS2rMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/link.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-link___pl",
    path: "/pl/cabinet/admin/blog/edit/:id()/link",
    meta: linkwTEKp3vS2rMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/link.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-link___ru",
    path: "/ru/cabinet/admin/blog/edit/:id()/link",
    meta: linkwTEKp3vS2rMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/link.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-news___en",
    path: "/en/cabinet/admin/blog/edit/:id()/news",
    meta: newsqEDpYBhmqpMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/news.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-news___uk",
    path: "/uk/cabinet/admin/blog/edit/:id()/news",
    meta: newsqEDpYBhmqpMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/news.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-news___pl",
    path: "/pl/cabinet/admin/blog/edit/:id()/news",
    meta: newsqEDpYBhmqpMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/news.vue")
  },
  {
    name: "cabinet-admin-blog-edit-id-news___ru",
    path: "/ru/cabinet/admin/blog/edit/:id()/news",
    meta: newsqEDpYBhmqpMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/edit/[id]/news.vue")
  },
  {
    name: "cabinet-admin-blog-faq___en",
    path: "/en/cabinet/admin/blog/faq",
    meta: faqqfmE4UIH5qMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/faq.vue")
  },
  {
    name: "cabinet-admin-blog-faq___uk",
    path: "/uk/cabinet/admin/blog/faq",
    meta: faqqfmE4UIH5qMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/faq.vue")
  },
  {
    name: "cabinet-admin-blog-faq___pl",
    path: "/pl/cabinet/admin/blog/faq",
    meta: faqqfmE4UIH5qMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/faq.vue")
  },
  {
    name: "cabinet-admin-blog-faq___ru",
    path: "/ru/cabinet/admin/blog/faq",
    meta: faqqfmE4UIH5qMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/faq.vue")
  },
  {
    name: "cabinet-admin-blog-files___en",
    path: "/en/cabinet/admin/blog/files",
    meta: filesNehs6a3BdqMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/files.vue")
  },
  {
    name: "cabinet-admin-blog-files___uk",
    path: "/uk/cabinet/admin/blog/files",
    meta: filesNehs6a3BdqMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/files.vue")
  },
  {
    name: "cabinet-admin-blog-files___pl",
    path: "/pl/cabinet/admin/blog/files",
    meta: filesNehs6a3BdqMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/files.vue")
  },
  {
    name: "cabinet-admin-blog-files___ru",
    path: "/ru/cabinet/admin/blog/files",
    meta: filesNehs6a3BdqMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/files.vue")
  },
  {
    name: "cabinet-admin-blog___en",
    path: "/en/cabinet/admin/blog",
    meta: indexfDrCh5Rxp1Meta || {},
    component: () => import("/app/pages/cabinet/admin/blog/index.vue")
  },
  {
    name: "cabinet-admin-blog___uk",
    path: "/uk/cabinet/admin/blog",
    meta: indexfDrCh5Rxp1Meta || {},
    component: () => import("/app/pages/cabinet/admin/blog/index.vue")
  },
  {
    name: "cabinet-admin-blog___pl",
    path: "/pl/cabinet/admin/blog",
    meta: indexfDrCh5Rxp1Meta || {},
    component: () => import("/app/pages/cabinet/admin/blog/index.vue")
  },
  {
    name: "cabinet-admin-blog___ru",
    path: "/ru/cabinet/admin/blog",
    meta: indexfDrCh5Rxp1Meta || {},
    component: () => import("/app/pages/cabinet/admin/blog/index.vue")
  },
  {
    name: "cabinet-admin-blog-links___en",
    path: "/en/cabinet/admin/blog/links",
    meta: linksHgAkqa8fKwMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/links.vue")
  },
  {
    name: "cabinet-admin-blog-links___uk",
    path: "/uk/cabinet/admin/blog/links",
    meta: linksHgAkqa8fKwMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/links.vue")
  },
  {
    name: "cabinet-admin-blog-links___pl",
    path: "/pl/cabinet/admin/blog/links",
    meta: linksHgAkqa8fKwMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/links.vue")
  },
  {
    name: "cabinet-admin-blog-links___ru",
    path: "/ru/cabinet/admin/blog/links",
    meta: linksHgAkqa8fKwMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/links.vue")
  },
  {
    name: "cabinet-admin-blog-new-faq___en",
    path: "/en/cabinet/admin/blog/new/faq",
    meta: faqyWKHXmPuOIMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/faq.vue")
  },
  {
    name: "cabinet-admin-blog-new-faq___uk",
    path: "/uk/cabinet/admin/blog/new/faq",
    meta: faqyWKHXmPuOIMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/faq.vue")
  },
  {
    name: "cabinet-admin-blog-new-faq___pl",
    path: "/pl/cabinet/admin/blog/new/faq",
    meta: faqyWKHXmPuOIMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/faq.vue")
  },
  {
    name: "cabinet-admin-blog-new-faq___ru",
    path: "/ru/cabinet/admin/blog/new/faq",
    meta: faqyWKHXmPuOIMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/faq.vue")
  },
  {
    name: "cabinet-admin-blog-new-file___en",
    path: "/en/cabinet/admin/blog/new/file",
    meta: filec6goFyR0rAMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/file.vue")
  },
  {
    name: "cabinet-admin-blog-new-file___uk",
    path: "/uk/cabinet/admin/blog/new/file",
    meta: filec6goFyR0rAMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/file.vue")
  },
  {
    name: "cabinet-admin-blog-new-file___pl",
    path: "/pl/cabinet/admin/blog/new/file",
    meta: filec6goFyR0rAMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/file.vue")
  },
  {
    name: "cabinet-admin-blog-new-file___ru",
    path: "/ru/cabinet/admin/blog/new/file",
    meta: filec6goFyR0rAMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/file.vue")
  },
  {
    name: "cabinet-admin-blog-new-link___en",
    path: "/en/cabinet/admin/blog/new/link",
    meta: linkvIc9fbzCZmMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/link.vue")
  },
  {
    name: "cabinet-admin-blog-new-link___uk",
    path: "/uk/cabinet/admin/blog/new/link",
    meta: linkvIc9fbzCZmMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/link.vue")
  },
  {
    name: "cabinet-admin-blog-new-link___pl",
    path: "/pl/cabinet/admin/blog/new/link",
    meta: linkvIc9fbzCZmMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/link.vue")
  },
  {
    name: "cabinet-admin-blog-new-link___ru",
    path: "/ru/cabinet/admin/blog/new/link",
    meta: linkvIc9fbzCZmMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/link.vue")
  },
  {
    name: "cabinet-admin-blog-new-news___en",
    path: "/en/cabinet/admin/blog/new/news",
    meta: newsCEikQBNDqGMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/news.vue")
  },
  {
    name: "cabinet-admin-blog-new-news___uk",
    path: "/uk/cabinet/admin/blog/new/news",
    meta: newsCEikQBNDqGMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/news.vue")
  },
  {
    name: "cabinet-admin-blog-new-news___pl",
    path: "/pl/cabinet/admin/blog/new/news",
    meta: newsCEikQBNDqGMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/news.vue")
  },
  {
    name: "cabinet-admin-blog-new-news___ru",
    path: "/ru/cabinet/admin/blog/new/news",
    meta: newsCEikQBNDqGMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/new/news.vue")
  },
  {
    name: "cabinet-admin-blog-news___en",
    path: "/en/cabinet/admin/blog/news",
    meta: newsZQbJLj3k3SMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/news.vue")
  },
  {
    name: "cabinet-admin-blog-news___uk",
    path: "/uk/cabinet/admin/blog/news",
    meta: newsZQbJLj3k3SMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/news.vue")
  },
  {
    name: "cabinet-admin-blog-news___pl",
    path: "/pl/cabinet/admin/blog/news",
    meta: newsZQbJLj3k3SMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/news.vue")
  },
  {
    name: "cabinet-admin-blog-news___ru",
    path: "/ru/cabinet/admin/blog/news",
    meta: newsZQbJLj3k3SMeta || {},
    component: () => import("/app/pages/cabinet/admin/blog/news.vue")
  },
  {
    name: "cabinet-admin-contacts-requests___en",
    path: "/en/cabinet/admin/contacts-requests",
    meta: contacts_45requestsjwwzQBJQCIMeta || {},
    component: () => import("/app/pages/cabinet/admin/contacts-requests.vue")
  },
  {
    name: "cabinet-admin-contacts-requests___uk",
    path: "/uk/cabinet/admin/contacts-requests",
    meta: contacts_45requestsjwwzQBJQCIMeta || {},
    component: () => import("/app/pages/cabinet/admin/contacts-requests.vue")
  },
  {
    name: "cabinet-admin-contacts-requests___pl",
    path: "/pl/cabinet/admin/contacts-requests",
    meta: contacts_45requestsjwwzQBJQCIMeta || {},
    component: () => import("/app/pages/cabinet/admin/contacts-requests.vue")
  },
  {
    name: "cabinet-admin-contacts-requests___ru",
    path: "/ru/cabinet/admin/contacts-requests",
    meta: contacts_45requestsjwwzQBJQCIMeta || {},
    component: () => import("/app/pages/cabinet/admin/contacts-requests.vue")
  },
  {
    name: "cabinet-admin-franchises___en",
    path: "/en/cabinet/admin/franchises",
    meta: franchisesDeyTRd2XISMeta || {},
    component: () => import("/app/pages/cabinet/admin/franchises.vue")
  },
  {
    name: "cabinet-admin-franchises___uk",
    path: "/uk/cabinet/admin/franchises",
    meta: franchisesDeyTRd2XISMeta || {},
    component: () => import("/app/pages/cabinet/admin/franchises.vue")
  },
  {
    name: "cabinet-admin-franchises___pl",
    path: "/pl/cabinet/admin/franchises",
    meta: franchisesDeyTRd2XISMeta || {},
    component: () => import("/app/pages/cabinet/admin/franchises.vue")
  },
  {
    name: "cabinet-admin-franchises___ru",
    path: "/ru/cabinet/admin/franchises",
    meta: franchisesDeyTRd2XISMeta || {},
    component: () => import("/app/pages/cabinet/admin/franchises.vue")
  },
  {
    name: "cabinet-admin___en",
    path: "/en/cabinet/admin",
    meta: index7eqYmXLl0NMeta || {},
    component: () => import("/app/pages/cabinet/admin/index.vue")
  },
  {
    name: "cabinet-admin___uk",
    path: "/uk/cabinet/admin",
    meta: index7eqYmXLl0NMeta || {},
    component: () => import("/app/pages/cabinet/admin/index.vue")
  },
  {
    name: "cabinet-admin___pl",
    path: "/pl/cabinet/admin",
    meta: index7eqYmXLl0NMeta || {},
    component: () => import("/app/pages/cabinet/admin/index.vue")
  },
  {
    name: "cabinet-admin___ru",
    path: "/ru/cabinet/admin",
    meta: index7eqYmXLl0NMeta || {},
    component: () => import("/app/pages/cabinet/admin/index.vue")
  },
  {
    name: "cabinet-admin-managers___en",
    path: "/en/cabinet/admin/managers",
    meta: managersW2uE2QEN2uMeta || {},
    component: () => import("/app/pages/cabinet/admin/managers.vue")
  },
  {
    name: "cabinet-admin-managers___uk",
    path: "/uk/cabinet/admin/managers",
    meta: managersW2uE2QEN2uMeta || {},
    component: () => import("/app/pages/cabinet/admin/managers.vue")
  },
  {
    name: "cabinet-admin-managers___pl",
    path: "/pl/cabinet/admin/managers",
    meta: managersW2uE2QEN2uMeta || {},
    component: () => import("/app/pages/cabinet/admin/managers.vue")
  },
  {
    name: "cabinet-admin-managers___ru",
    path: "/ru/cabinet/admin/managers",
    meta: managersW2uE2QEN2uMeta || {},
    component: () => import("/app/pages/cabinet/admin/managers.vue")
  },
  {
    name: "cabinet-admin-stat___en",
    path: "/en/cabinet/admin/stat",
    meta: stat7Jhwz6YuXwMeta || {},
    component: () => import("/app/pages/cabinet/admin/stat.vue")
  },
  {
    name: "cabinet-admin-stat___uk",
    path: "/uk/cabinet/admin/stat",
    meta: stat7Jhwz6YuXwMeta || {},
    component: () => import("/app/pages/cabinet/admin/stat.vue")
  },
  {
    name: "cabinet-admin-stat___pl",
    path: "/pl/cabinet/admin/stat",
    meta: stat7Jhwz6YuXwMeta || {},
    component: () => import("/app/pages/cabinet/admin/stat.vue")
  },
  {
    name: "cabinet-admin-stat___ru",
    path: "/ru/cabinet/admin/stat",
    meta: stat7Jhwz6YuXwMeta || {},
    component: () => import("/app/pages/cabinet/admin/stat.vue")
  },
  {
    name: "cabinet-dashboard___en",
    path: "/en/cabinet/dashboard",
    meta: dashboardKHX7remamBMeta || {},
    component: () => import("/app/pages/cabinet/dashboard.vue")
  },
  {
    name: "cabinet-dashboard___uk",
    path: "/uk/cabinet/dashboard",
    meta: dashboardKHX7remamBMeta || {},
    component: () => import("/app/pages/cabinet/dashboard.vue")
  },
  {
    name: "cabinet-dashboard___pl",
    path: "/pl/cabinet/dashboard",
    meta: dashboardKHX7remamBMeta || {},
    component: () => import("/app/pages/cabinet/dashboard.vue")
  },
  {
    name: "cabinet-dashboard___ru",
    path: "/ru/cabinet/dashboard",
    meta: dashboardKHX7remamBMeta || {},
    component: () => import("/app/pages/cabinet/dashboard.vue")
  },
  {
    name: "cabinet___en",
    path: "/en/cabinet",
    meta: indexnwhO39W8KgMeta || {},
    component: () => import("/app/pages/cabinet/index.vue")
  },
  {
    name: "cabinet___uk",
    path: "/uk/cabinet",
    meta: indexnwhO39W8KgMeta || {},
    component: () => import("/app/pages/cabinet/index.vue")
  },
  {
    name: "cabinet___pl",
    path: "/pl/cabinet",
    meta: indexnwhO39W8KgMeta || {},
    component: () => import("/app/pages/cabinet/index.vue")
  },
  {
    name: "cabinet___ru",
    path: "/ru/cabinet",
    meta: indexnwhO39W8KgMeta || {},
    component: () => import("/app/pages/cabinet/index.vue")
  },
  {
    name: "cabinet-profile___en",
    path: "/en/cabinet/profile",
    meta: profile2UaO9VJ68ZMeta || {},
    component: () => import("/app/pages/cabinet/profile.vue")
  },
  {
    name: "cabinet-profile___uk",
    path: "/uk/cabinet/profile",
    meta: profile2UaO9VJ68ZMeta || {},
    component: () => import("/app/pages/cabinet/profile.vue")
  },
  {
    name: "cabinet-profile___pl",
    path: "/pl/cabinet/profile",
    meta: profile2UaO9VJ68ZMeta || {},
    component: () => import("/app/pages/cabinet/profile.vue")
  },
  {
    name: "cabinet-profile___ru",
    path: "/ru/cabinet/profile",
    meta: profile2UaO9VJ68ZMeta || {},
    component: () => import("/app/pages/cabinet/profile.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___uk",
    path: "/uk/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___pl",
    path: "/pl/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___ru",
    path: "/ru/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "documents-accounting___en",
    path: "/en/documents/accounting",
    component: () => import("/app/pages/documents/accounting.vue")
  },
  {
    name: "documents-accounting___uk",
    path: "/uk/documents/accounting",
    component: () => import("/app/pages/documents/accounting.vue")
  },
  {
    name: "documents-accounting___pl",
    path: "/pl/documents/accounting",
    component: () => import("/app/pages/documents/accounting.vue")
  },
  {
    name: "documents-accounting___ru",
    path: "/ru/documents/accounting",
    component: () => import("/app/pages/documents/accounting.vue")
  },
  {
    name: "documents-cookies___en",
    path: "/en/documents/cookies",
    component: () => import("/app/pages/documents/cookies.vue")
  },
  {
    name: "documents-cookies___uk",
    path: "/uk/documents/cookies",
    component: () => import("/app/pages/documents/cookies.vue")
  },
  {
    name: "documents-cookies___pl",
    path: "/pl/documents/cookies",
    component: () => import("/app/pages/documents/cookies.vue")
  },
  {
    name: "documents-cookies___ru",
    path: "/ru/documents/cookies",
    component: () => import("/app/pages/documents/cookies.vue")
  },
  {
    name: "documents-discount-codes___en",
    path: "/en/documents/discount-codes",
    component: () => import("/app/pages/documents/discount-codes.vue")
  },
  {
    name: "documents-discount-codes___uk",
    path: "/uk/documents/discount-codes",
    component: () => import("/app/pages/documents/discount-codes.vue")
  },
  {
    name: "documents-discount-codes___pl",
    path: "/pl/documents/discount-codes",
    component: () => import("/app/pages/documents/discount-codes.vue")
  },
  {
    name: "documents-discount-codes___ru",
    path: "/ru/documents/discount-codes",
    component: () => import("/app/pages/documents/discount-codes.vue")
  },
  {
    name: "documents-rodo___en",
    path: "/en/documents/rodo",
    component: () => import("/app/pages/documents/rodo.vue")
  },
  {
    name: "documents-rodo___uk",
    path: "/uk/documents/rodo",
    component: () => import("/app/pages/documents/rodo.vue")
  },
  {
    name: "documents-rodo___pl",
    path: "/pl/documents/rodo",
    component: () => import("/app/pages/documents/rodo.vue")
  },
  {
    name: "documents-rodo___ru",
    path: "/ru/documents/rodo",
    component: () => import("/app/pages/documents/rodo.vue")
  },
  {
    name: "franchising___en",
    path: "/en/franchising",
    component: () => import("/app/pages/franchising/index.vue")
  },
  {
    name: "franchising___uk",
    path: "/uk/franchising",
    component: () => import("/app/pages/franchising/index.vue")
  },
  {
    name: "franchising___pl",
    path: "/pl/franchising",
    component: () => import("/app/pages/franchising/index.vue")
  },
  {
    name: "franchising___ru",
    path: "/ru/franchising",
    component: () => import("/app/pages/franchising/index.vue")
  },
  {
    name: "franchising-page-page___en",
    path: "/en/franchising/page-:page()",
    component: () => import("/app/pages/franchising/page-[:page].vue")
  },
  {
    name: "franchising-page-page___uk",
    path: "/uk/franchising/page-:page()",
    component: () => import("/app/pages/franchising/page-[:page].vue")
  },
  {
    name: "franchising-page-page___pl",
    path: "/pl/franchising/page-:page()",
    component: () => import("/app/pages/franchising/page-[:page].vue")
  },
  {
    name: "franchising-page-page___ru",
    path: "/ru/franchising/page-:page()",
    component: () => import("/app/pages/franchising/page-[:page].vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "invoice-id-edit___en",
    path: "/en/invoice/:id()/edit",
    component: () => import("/app/pages/invoice/[id]/edit.vue")
  },
  {
    name: "invoice-id-edit___uk",
    path: "/uk/invoice/:id()/edit",
    component: () => import("/app/pages/invoice/[id]/edit.vue")
  },
  {
    name: "invoice-id-edit___pl",
    path: "/pl/invoice/:id()/edit",
    component: () => import("/app/pages/invoice/[id]/edit.vue")
  },
  {
    name: "invoice-id-edit___ru",
    path: "/ru/invoice/:id()/edit",
    component: () => import("/app/pages/invoice/[id]/edit.vue")
  },
  {
    name: "invoice___en",
    path: "/en/invoice",
    meta: indexvxYgcCJQGtMeta || {},
    component: () => import("/app/pages/invoice/index.vue")
  },
  {
    name: "invoice___uk",
    path: "/uk/invoice",
    meta: indexvxYgcCJQGtMeta || {},
    component: () => import("/app/pages/invoice/index.vue")
  },
  {
    name: "invoice___pl",
    path: "/pl/invoice",
    meta: indexvxYgcCJQGtMeta || {},
    component: () => import("/app/pages/invoice/index.vue")
  },
  {
    name: "invoice___ru",
    path: "/ru/invoice",
    meta: indexvxYgcCJQGtMeta || {},
    component: () => import("/app/pages/invoice/index.vue")
  },
  {
    name: "invoice-my-info___en",
    path: "/en/invoice/my-info",
    meta: my_45infoPkQHrCIZFrMeta || {},
    component: () => import("/app/pages/invoice/my-info.vue")
  },
  {
    name: "invoice-my-info___uk",
    path: "/uk/invoice/my-info",
    meta: my_45infoPkQHrCIZFrMeta || {},
    component: () => import("/app/pages/invoice/my-info.vue")
  },
  {
    name: "invoice-my-info___pl",
    path: "/pl/invoice/my-info",
    meta: my_45infoPkQHrCIZFrMeta || {},
    component: () => import("/app/pages/invoice/my-info.vue")
  },
  {
    name: "invoice-my-info___ru",
    path: "/ru/invoice/my-info",
    meta: my_45infoPkQHrCIZFrMeta || {},
    component: () => import("/app/pages/invoice/my-info.vue")
  },
  {
    name: "invoice-my-invoices___en",
    path: "/en/invoice/my-invoices",
    meta: my_45invoicesg5wtmcDfRuMeta || {},
    component: () => import("/app/pages/invoice/my-invoices.vue")
  },
  {
    name: "invoice-my-invoices___uk",
    path: "/uk/invoice/my-invoices",
    meta: my_45invoicesg5wtmcDfRuMeta || {},
    component: () => import("/app/pages/invoice/my-invoices.vue")
  },
  {
    name: "invoice-my-invoices___pl",
    path: "/pl/invoice/my-invoices",
    meta: my_45invoicesg5wtmcDfRuMeta || {},
    component: () => import("/app/pages/invoice/my-invoices.vue")
  },
  {
    name: "invoice-my-invoices___ru",
    path: "/ru/invoice/my-invoices",
    meta: my_45invoicesg5wtmcDfRuMeta || {},
    component: () => import("/app/pages/invoice/my-invoices.vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___uk",
    path: "/uk/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___pl",
    path: "/pl/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___ru",
    path: "/ru/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "prices___en",
    path: "/en/prices",
    component: () => import("/app/pages/prices.vue")
  },
  {
    name: "prices___uk",
    path: "/uk/prices",
    component: () => import("/app/pages/prices.vue")
  },
  {
    name: "prices___pl",
    path: "/pl/prices",
    component: () => import("/app/pages/prices.vue")
  },
  {
    name: "prices___ru",
    path: "/ru/prices",
    component: () => import("/app/pages/prices.vue")
  },
  {
    name: "restore-password___en",
    path: "/en/restore-password",
    component: () => import("/app/pages/restore-password.vue")
  },
  {
    name: "restore-password___uk",
    path: "/uk/restore-password",
    component: () => import("/app/pages/restore-password.vue")
  },
  {
    name: "restore-password___pl",
    path: "/pl/restore-password",
    component: () => import("/app/pages/restore-password.vue")
  },
  {
    name: "restore-password___ru",
    path: "/ru/restore-password",
    component: () => import("/app/pages/restore-password.vue")
  },
  {
    name: "services-slug___en",
    path: "/en/services/:slug()",
    component: () => import("/app/pages/services/[slug].vue")
  },
  {
    name: "services-slug___uk",
    path: "/uk/services/:slug()",
    component: () => import("/app/pages/services/[slug].vue")
  },
  {
    name: "services-slug___pl",
    path: "/pl/services/:slug()",
    component: () => import("/app/pages/services/[slug].vue")
  },
  {
    name: "services-slug___ru",
    path: "/ru/services/:slug()",
    component: () => import("/app/pages/services/[slug].vue")
  },
  {
    name: "verify-email-secret___en",
    path: "/en/verify-email/:secret()",
    component: () => import("/app/pages/verify-email/[secret].vue")
  },
  {
    name: "verify-email-secret___uk",
    path: "/uk/verify-email/:secret()",
    component: () => import("/app/pages/verify-email/[secret].vue")
  },
  {
    name: "verify-email-secret___pl",
    path: "/pl/verify-email/:secret()",
    component: () => import("/app/pages/verify-email/[secret].vue")
  },
  {
    name: "verify-email-secret___ru",
    path: "/ru/verify-email/:secret()",
    component: () => import("/app/pages/verify-email/[secret].vue")
  }
]